(function () {
function init(root) {
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
var all = JSON.parse(root.querySelector('[data-items]').textContent);
var cfg = JSON.parse(root.querySelector('[data-config]').textContent);
var compact = cfg.mode === 'compact';
var sheetEl = root.querySelector('[data-sheet]'), gridEl = root.querySelector('[data-grid]');
document.querySelectorAll('body > [data-ssd-owner="' + root.id + '"]').forEach(function (n) { n.remove(); });
sheetEl.setAttribute('data-ssd-owner', root.id); gridEl.setAttribute('data-ssd-owner', root.id);
document.body.appendChild(sheetEl); document.body.appendChild(gridEl);
var $ = function (s) { return root.querySelector(s) || sheetEl.querySelector(s) || gridEl.querySelector(s); };
var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)).concat([].slice.call(sheetEl.querySelectorAll(s)), [].slice.call(gridEl.querySelectorAll(s))); };
/* ---------- names + colours for parts ---------- */
var ACC = { black: ['Black', '#151515'], grey: ['Grey', '#b9b9b9'], dblue: ['Dark Blue', '#1a2ad8'], green: ['Green', '#2fd84a'], lblue: ['Light Blue', '#5fd3f0'], orange: ['Orange', '#ff6a00'], red: ['Red', '#e01616'], pink: ['Pink', '#f59fdb'] };
var NOSE = { black: ['Black', '#151515'], white: ['White', '#ffffff'], red: ['Red', '#e01616'], orange: ['Orange', '#ff6a00'], pink: ['Pink', '#f59fdb'], darkblue: ['Dark Blue', '#1a2ad8'], lightblue: ['Light Blue', '#5fd3f0'] };
function armParts(code) {
var base = code.indexOf('clear') === 0 ? 'clear' : 'black';
var acc = code.slice(base.length);
var a = ACC[acc] || [acc, '#999'];
return { base: base, acc: a[1], label: (code === 'blackblack' ? 'All Black' : (base === 'clear' ? 'Clear' : 'Black') + ' / ' + a[0]) };
}
function noseInfo(code) { var n = NOSE[code.toLowerCase()] || [code, '#999']; return { label: n[0], hex: n[1] }; }
/* ---------- colour helpers ---------- */
function hex2rgb(h) { h = (h || '#cccccc').replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); var n = parseInt(h, 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
function mix(a, b, t) { return [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * t); }); }
function css(c) { return 'rgb(' + c.join(',') + ')'; }
all.forEach(function (it, i) { it.k = i; it.rgb = hex2rgb(it.tint); });
function lensStyle(it) {
return it.lens ? 'background-image:url(' + it.lens + ');background-size:cover;background-position:center'
: (it.img ? 'background-image:url(' + it.img + ');background-size:650%;background-position:44% 68%' : '');
}
/* ---------- groups: REVO mirror vs clear never share a dial ---------- */
var groups = [];
all.forEach(function (it) { if (groups.indexOf(it.group) < 0) groups.push(it.group); });
var startItem = all[parseInt(root.dataset.start, 10) || 0] || all[0];
if (compact) {
var pref = all.filter(function (it) { return it.group === cfg.startGroup; });
if (pref.length) startItem = pref.filter(function (it) { return it.available; })[0] || pref[0];
}
var group = startItem.group, items = [], N = 0;
var pos = 0, target = 0, current = -1;
var armMode = 'both', armSide = 'L';
var sel = { L: 'blackblack', R: 'blackblack', nose: 'black' };
if (cfg.armsAvailable.indexOf(sel.L) < 0 && cfg.armsAvailable.length) sel.L = sel.R = cfg.armsAvailable[0];
/* ---------- build stage, words, dial for the active group ---------- */
var track = $('[data-track]'), words = $('[data-words]'), strip = $('[data-dial-strip]');
var itemEls = [], wordEls = [], lensEls = [], tickEls = [];
var countAll = $('[data-count-all]');
function build() {
items = all.filter(function (it) { return it.group === group; });
N = items.length;
track.innerHTML = ''; words.innerHTML = ''; strip.innerHTML = '';
itemEls = []; wordEls = []; lensEls = []; tickEls = [];
items.forEach(function (it, i) {
var el = document.createElement('div');
el.className = 'ssd__item' + (it.available ? '' : ' is-out');
el.innerHTML = '<div class="ssd__float"><img alt="' + it.title.replace(/"/g, '&quot;') + '" src="' + (it.img || '') + '" draggable="false"><div class="ssd__sheen" style="--img:url(' + it.img + ')"></div></div>';
el.addEventListener('click', function () { if (moved) return; if (compact && i === Math.round(clamp(pos))) { location.href = items[i].url; return; } go(i); });
track.appendChild(el); itemEls.push(el);
var w = document.createElement('span');
w.className = 'ssd__word'; w.textContent = it.name;
words.appendChild(w); wordEls.push(w);
var b = document.createElement('button');
b.type = 'button'; b.className = 'ssd__lens-btn' + (it.available ? '' : ' is-out');
b.setAttribute('aria-label', it.name + (it.available ? '' : ' (sold out)'));
b.setAttribute('style', '--c:' + it.tint + ';' + lensStyle(it));
b.addEventListener('click', function () { if (!moved) go(i); });
strip.appendChild(b); lensEls.push(b);
if (i < N - 1) { var t = document.createElement('span'); t.className = 'ssd__tick'; strip.appendChild(t); tickEls.push(t); }
});
if (countAll) countAll.textContent = (N < 10 ? '0' : '') + N;
$$('[data-group]').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.group === group); });
root.setAttribute('data-active-group', group);
var dial = $('[data-dial]'); dial.setAttribute('aria-valuemax', N);
}
function setGroup(g, k) {
if (g === group && k === undefined) return;
var same = g === group;
group = g;
var go2 = function () {
if (!same) build();
var idx = 0;
if (k !== undefined) items.forEach(function (it, i) { if (it.k === k) idx = i; });
else { var av = items.map(function (it) { return it.available; }).indexOf(true); idx = av > -1 ? av : 0; }
if (!same) { pos = target = idx; current = -1; lastTick = idx; render(); settle(); }
else go(idx);
};
if (same) { go2(); return; }
root.classList.add('is-switching');
setTimeout(function () { go2(); root.classList.remove('is-switching'); }, 220);
}
/* ---------- render loop ---------- */
var stage = $('[data-stage]'), bg = $('[data-bg]'), visorTint = $('[data-visor-tint]');
var GAP = (compact ? 6 : 7.4) * parseFloat(getComputedStyle(document.documentElement).fontSize || 10);
var raf = 0, dragging = false, lastTick = 0;
function W() { return stage.clientWidth; }
function tintAt(p) {
var a = Math.max(0, Math.min(N - 1, Math.floor(p))), b = Math.min(N - 1, a + 1);
return mix(items[a].rgb, items[b].rgb, Math.max(0, Math.min(1, p - a)));
}
function render() {
if (!N) return;
var w = W(), dw = strip.clientWidth, mobile = w < 750;
for (var i = 0; i < N; i++) {
var d = i - pos, ad = Math.abs(d);
var el = itemEls[i];
if (ad > 2.6) { el.style.opacity = 0; el.style.visibility = 'hidden'; }
else {
el.style.visibility = 'visible';
var x = d * w * (mobile ? 0.66 : 0.42);
var s = 1 - Math.min(ad, 2) * 0.3;
el.style.transform = 'translate3d(' + x + 'px,' + (ad * 14) + 'px,0) rotate(' + (d * -9) + 'deg) scale(' + s + ')';
el.style.opacity = Math.max(0, 1 - ad * 0.5);
el.style.filter = ad > 0.05 ? 'blur(' + (ad * 2.5).toFixed(2) + 'px)' : 'none';
el.style.zIndex = 100 - Math.round(ad * 10);
}
var we = wordEls[i];
if (ad > 1.4) { we.style.opacity = 0; }
else {
we.style.opacity = Math.max(0, 1 - ad * 1.1);
we.style.transform = 'translate3d(calc(-50% + ' + (d * w * 0.9) + 'px), -50%, 0)';
}
var lx = dw / 2 + d * GAP;
lensEls[i].style.transform = 'translate3d(' + lx + 'px,0,0) scale(' + (1 + Math.max(0, 1 - ad) * 0.18) + ')';
lensEls[i].style.opacity = Math.max(0.25, 1 - Math.max(0, ad - 2) * 0.25);
if (i < N - 1) tickEls[i].style.transform = 'translate3d(' + (lx + GAP / 2) + 'px,0,0)';
}
var t = tintAt(pos), soft = css(mix(t, [255, 255, 255], 0.6));
bg.style.backgroundColor = soft;
root.style.setProperty('--bg-soft', soft);
root.style.setProperty('--tint', css(t));
sheetEl.style.setProperty('--bg-soft', soft);
if (visorTint) visorTint.style.backgroundColor = css(t);
}
function loop() {
raf = 0;
if (!dragging) {
var diff = target - pos;
if (Math.abs(diff) < 0.001) { pos = target; render(); settle(); return; }
pos += diff * 0.16;
}
render();
var r = Math.round(Math.max(0, Math.min(N - 1, pos)));
if (r !== lastTick) { lastTick = r; buzz(); live(r); }
raf = requestAnimationFrame(loop);
}
function kick() { if (!raf) raf = requestAnimationFrame(loop); }
function buzz() { try { if (navigator.vibrate && dragging) navigator.vibrate(6); } catch (e) {} }
function clamp(v) { return Math.max(0, Math.min(N - 1, v)); }
function go(i) { target = clamp(i); hideHint(); kick(); }
function cur() { return items[Math.round(clamp(pos))] || items[0]; }
/* ---------- live updates while moving ---------- */
var chipLens = $('[data-chip-lens]'), countNow = $('[data-count-now]');
function live(i) {
i = clamp(i);
var it = items[i];
chipLens.setAttribute('style', lensStyle(it));
countNow.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
var chip = $('[data-open-grid]'); chip.classList.remove('is-pop'); void chip.offsetWidth; chip.classList.add('is-pop');
setInfo(i);
}
/* ---------- info panel ---------- */
var nameEl = $('[data-name]'), typeEl = $('[data-lens-type]'), priceEl = $('[data-price]'), stockEl = $('[data-stock]');
var addBtn = $('[data-add]'), addLabel = $('[data-add-label]'), buyBtn = $('[data-buy-now]');
var throughLabel = $('[data-through-label]'), detailsEl = $('[data-details]'), fullLink = $('[data-full-link]');
if (fullLink) fullLink.addEventListener('click', function (e) { if (fullLink.classList.contains('is-out')) e.preventDefault(); });
function setInfo(i) {
var it = items[i];
if (nameEl.textContent !== it.name) { nameEl.textContent = it.name; nameEl.classList.remove('is-swap'); void nameEl.offsetWidth; nameEl.classList.add('is-swap'); }
typeEl.textContent = it.group === 'mirror' ? 'Coated lens (REVO mirror)' : 'Clear lens';
priceEl.innerHTML = (it.compare ? '<s>' + it.compare + '</s>' : '') + it.price;
stockEl.className = 'ssd__stock';
if (!it.available) { stockEl.textContent = 'Sold out'; stockEl.classList.add('is-out'); }
else if (it.qty !== null && it.qty <= (cfg.lowStock != null ? cfg.lowStock : 10)) { stockEl.textContent = 'Only ' + it.qty + ' left'; stockEl.classList.add('is-low'); }
else { stockEl.textContent = 'In stock'; }
var off = cfg.dropClosed || !it.available;
if (addBtn) { addBtn.disabled = off; addLabel.textContent = cfg.dropClosed ? 'Drop closed' : (it.available ? 'Add to cart' : 'Sold out'); }
if (buyBtn) buyBtn.disabled = off;
throughLabel.textContent = 'Looking through ' + it.name;
if (detailsEl && it.desc !== undefined) detailsEl.innerHTML = it.desc;
if (fullLink) {
fullLink.setAttribute('href', it.url);
fullLink.classList.toggle('is-out', !it.available);
fullLink.setAttribute('aria-label', it.available ? 'View ' + it.title : it.title + ' (sold out)');
if (it.available) fullLink.removeAttribute('aria-disabled'); else fullLink.setAttribute('aria-disabled', 'true');
}
var dial = $('[data-dial]');
dial.setAttribute('aria-valuenow', i + 1);
dial.setAttribute('aria-valuetext', it.name);
drawMini();
}
/* ---------- settle: sheen, URL, details below ---------- */
var detailTimer;
function settle() {
var i = Math.round(clamp(pos));
itemEls.forEach(function (el, k) { el.classList.toggle('is-current', k === i); });
if (i === current) return;
current = i;
var el = itemEls[i];
el.classList.remove('is-sheen'); void el.offsetWidth; el.classList.add('is-sheen');
live(i);
if (!cfg.updateUrl) return;
var it = items[i];
if (location.pathname !== it.url && history.replaceState) {
history.replaceState(history.state, '', it.url + location.search);
document.title = it.title + ' – ' + document.title.split(' – ').slice(-1)[0];
}
clearTimeout(detailTimer);
detailTimer = setTimeout(function () { loadDetails(it); }, 380);
}
var detailsUrl = location.pathname;
function loadDetails(it) {
if (it.url === detailsUrl) return;
var box = document.querySelector(cfg.mainSelector);
var sec = box && box.closest('.shopify-section');
if (!sec) return;
detailsUrl = it.url;
fetch(it.url + '?section_id=' + sec.id.replace('shopify-section-', ''))
.then(function (r) { return r.ok ? r.text() : null; })
.then(function (html) {
if (!html || detailsUrl !== it.url) return;
var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.product__info-container');
if (fresh) box.innerHTML = fresh.innerHTML;
}).catch(function () {});
}
/* ---------- dragging (stage + dial) ---------- */
var moved = false;
function drag(el, unitFn) {
var sx = 0, sy = 0, sp = 0, lastX = 0, lastT = 0, vx = 0, axis = null, id = null;
el.addEventListener('pointerdown', function (e) {
if (e.button > 0) return;
id = e.pointerId; sx = lastX = e.clientX; sy = e.clientY; sp = pos; lastT = performance.now(); vx = 0; axis = null; moved = false;
});
el.addEventListener('pointermove', function (e) {
if (id !== e.pointerId) return;
var dx = e.clientX - sx, dy = e.clientY - sy;
if (!axis) {
if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
if (axis === 'x') { dragging = true; moved = true; hideHint(); stage.classList.add('is-dragging'); try { el.setPointerCapture(id); } catch (err) {} }
}
if (axis !== 'x') return;
e.preventDefault();
var p = sp - dx / unitFn();
if (p < 0) p = p * 0.35; else if (p > N - 1) p = N - 1 + (p - (N - 1)) * 0.35;
pos = p;
var now = performance.now(), dt = Math.max(1, now - lastT);
vx = 0.8 * vx + 0.2 * ((e.clientX - lastX) / dt); lastX = e.clientX; lastT = now;
kick();
}, { passive: false });
function end(e) {
if (id !== e.pointerId) return;
id = null;
if (dragging) {
dragging = false; stage.classList.remove('is-dragging');
var fling = -vx * 120 / unitFn();
target = clamp(Math.round(pos + Math.max(-1, Math.min(1, fling))));
kick();
}
setTimeout(function () { moved = false; }, 0);
}
el.addEventListener('pointerup', end);
el.addEventListener('pointercancel', end);
}
drag(stage, function () { return W() * (W() < 750 ? 0.66 : 0.42); });
var dial = $('[data-dial]');
drag(dial, function () { return GAP; });
dial.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(target + 1); }
else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(target - 1); }
else if (e.key === 'Home') { e.preventDefault(); go(0); }
else if (e.key === 'End') { e.preventDefault(); go(N - 1); }
});
var wheelLock = 0;
stage.addEventListener('wheel', function (e) {
if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
e.preventDefault();
var now = Date.now(); if (now - wheelLock < 260) return; wheelLock = now;
go(target + (e.deltaX > 0 ? 1 : -1));
}, { passive: false });
window.addEventListener('resize', function () { render(); });
window.addEventListener('load', function () { render(); });
if (window.ResizeObserver) new ResizeObserver(function () { render(); }).observe(root);
/* ---------- group toggle ---------- */
$$('[data-group]').forEach(function (b) {
b.addEventListener('click', function () { hideHint(); setGroup(b.dataset.group); });
});
/* ---------- hint ---------- */
var hint = $('[data-hint]'), hinted = false;
function hideHint() { hinted = true; hint.classList.remove('is-on'); }
try { hinted = sessionStorage.getItem('ssd-hint') === '1'; } catch (e) {}
if (!hinted) {
setTimeout(function () {
if (hinted || N < 2) return;
hint.classList.add('is-on');
var base = target, peek = base < N - 1 ? base + 0.32 : base - 0.32;
target = peek; kick();
setTimeout(function () { if (target === peek) { target = base; kick(); } }, 520);
setTimeout(function () { hint.classList.remove('is-on'); }, 3800);
try { sessionStorage.setItem('ssd-hint', '1'); } catch (e) {}
}, 1300);
}
/* ---------- see-through ---------- */
var seeBtn = $('[data-see]'), seeLabel = $('[data-see-label]');
seeBtn.addEventListener('click', function () {
var on = !root.classList.contains('is-through');
root.classList.toggle('is-through', on);
seeBtn.setAttribute('aria-pressed', on);
seeLabel.textContent = on ? 'Show pair' : 'See through';
hideHint();
});
/* ---------- all-lenses grid (both groups, labelled) ---------- */
var grid = gridEl, gridList = $('[data-grid-list]');
var GL = { mirror: 'Coated', clear: 'Clear' };
groups.forEach(function (g) {
var h = document.createElement('p'); h.className = 'ssd__grid-group'; h.textContent = GL[g] || g;
gridList.appendChild(h);
all.filter(function (it) { return it.group === g; }).forEach(function (it) {
var c = document.createElement('button');
c.type = 'button'; c.className = 'ssd__card' + (it.available ? '' : ' is-out'); c.dataset.k = it.k;
c.innerHTML = '<span class="ssd__card-img" style="background:' + css(mix(it.rgb, [255, 255, 255], 0.7)) + '"><img loading="lazy" alt="" src="' + (it.img || '') + '"></span>' +
'<span class="ssd__card-name"><span>' + it.name + '</span><span>' + (it.available ? it.price : 'Sold out') + '</span></span>';
c.addEventListener('click', function () { closeGrid(); setTimeout(function () { setGroup(it.group, it.k); }, 120); });
gridList.appendChild(c);
});
});
function openGrid() {
var k = cur().k;
gridList.querySelectorAll('.ssd__card').forEach(function (c) { c.setAttribute('aria-current', +c.dataset.k === k); });
grid.hidden = false; document.documentElement.style.overflow = 'hidden'; hideHint();
grid.querySelector('[data-close-grid]').focus();
}
function closeGrid() { grid.hidden = true; document.documentElement.style.overflow = ''; }
$('[data-open-grid]').addEventListener('click', openGrid);
grid.querySelector('[data-close-grid]').addEventListener('click', closeGrid);
/* ---------- order now (compact / home) ---------- */
var buyPanel = $('[data-buy-panel]'), orderBtn = $('[data-order]');
if (orderBtn && buyPanel) {
orderBtn.addEventListener('click', function () {
var open = !root.classList.contains('is-open');
root.classList.toggle('is-open', open);
orderBtn.setAttribute('aria-expanded', open);
buyPanel.setAttribute('aria-hidden', !open);
hideHint();
if (open && window.innerWidth < 990) setTimeout(function () {
var r = root.querySelector('.ssd__head').getBoundingClientRect();
window.scrollTo({ top: window.scrollY + r.top - 16, behavior: 'smooth' });
}, 80);
});
}
/* ---------- customize sheet ---------- */
var sheet = sheetEl, armsBox = $('[data-arms]'), nosesBox = $('[data-noses]');
var armPicked = $('[data-arm-picked]'), nosePicked = $('[data-nose-picked]'), customSub = $('[data-custom-sub]');
cfg.arms.forEach(function (code) {
var a = armParts(code), ok = cfg.armsAvailable.indexOf(code) > -1;
var b = document.createElement('button');
b.type = 'button'; b.className = 'ssd__sw'; b.dataset.arm = code; b.disabled = !ok;
var baseFill = a.base === 'clear' ? 'linear-gradient(135deg,#f4f8fa,#d5dde2)' : '#151515';
b.innerHTML = '<span class="ssd__sw-dot" style="background:linear-gradient(120deg, transparent 58%, ' + a.acc + ' 58%), ' + baseFill + '"></span><span>' + a.label + (ok ? '' : '<br>Sold out') + '</span>';
b.addEventListener('click', function () {
if (armMode === 'both') { sel.L = sel.R = code; }
else { sel[armSide] = code; armSide = armSide === 'L' ? 'R' : 'L'; syncSide(); }
syncSheet();
});
armsBox.appendChild(b);
});
cfg.noses.forEach(function (code) {
var n = noseInfo(code);
var b = document.createElement('button');
b.type = 'button'; b.className = 'ssd__sw'; b.dataset.nose = code;
b.innerHTML = '<span class="ssd__sw-dot" style="background:' + n.hex + '"></span><span>' + n.label + '</span>';
b.addEventListener('click', function () { sel.nose = code; syncSheet(); });
nosesBox.appendChild(b);
});
$$('[data-arm-mode]').forEach(function (b) {
b.addEventListener('click', function () {
armMode = b.dataset.armMode;
$$('[data-arm-mode]').forEach(function (x) { x.setAttribute('aria-selected', x === b); });
$('[data-side-pick]').hidden = armMode !== 'mix';
if (armMode === 'both') sel.R = sel.L;
armSide = 'L'; syncSide(); syncSheet();
});
});
$$('[data-side]').forEach(function (b) {
b.addEventListener('click', function () { armSide = b.dataset.side; syncSide(); });
});
function syncSide() { $$('[data-side]').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.side === armSide); }); }
function syncSheet() {
armsBox.querySelectorAll('.ssd__sw').forEach(function (b) {
var c = b.dataset.arm, on = c === sel.L || c === sel.R;
b.setAttribute('aria-pressed', on);
var dot = b.querySelector('.ssd__sw-dot'), tag = dot.querySelector('.ssd__sw-tag');
var txt = armMode === 'mix' ? (c === sel.L && c === sel.R ? 'L+R' : c === sel.L ? 'L' : c === sel.R ? 'R' : '') : '';
if (txt) { if (!tag) { tag = document.createElement('span'); tag.className = 'ssd__sw-tag'; dot.appendChild(tag); } tag.textContent = txt; }
else if (tag) tag.remove();
});
nosesBox.querySelectorAll('.ssd__sw').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.nose === sel.nose); });
var L = armParts(sel.L).label, R = armParts(sel.R).label, nose = noseInfo(sel.nose).label;
armPicked.textContent = sel.L === sel.R ? 'Both arms: ' + L : 'Left: ' + L + ' · Right: ' + R;
nosePicked.textContent = 'Nose pads: ' + nose;
if (customSub) customSub.textContent = (sel.L === sel.R ? 'Arms ' + L : 'Arms ' + L + ' + ' + R) + ' · Nose ' + nose;
drawMini();
}
function openSheet() { sheet.hidden = false; sheet.classList.remove('is-closing'); document.documentElement.style.overflow = 'hidden'; hideHint(); }
function closeSheet() {
sheet.classList.add('is-closing');
setTimeout(function () { sheet.hidden = true; sheet.classList.remove('is-closing'); document.documentElement.style.overflow = ''; }, 240);
}
var openBtn = $('[data-open-sheet]'); if (openBtn) openBtn.addEventListener('click', openSheet);
$$('[data-close-sheet]').forEach(function (b) { b.addEventListener('click', closeSheet); });
document.addEventListener('keydown', function (e) {
if (e.key !== 'Escape') return;
if (!sheet.hidden) closeSheet();
if (!grid.hidden) closeGrid();
});
(function () {
var panel = sheet.querySelector('.ssd__sheet-panel'), sy = null, dy = 0;
panel.addEventListener('touchstart', function (e) { if (panel.scrollTop <= 0) sy = e.touches[0].clientY; }, { passive: true });
panel.addEventListener('touchmove', function (e) { if (sy === null) return; dy = Math.max(0, e.touches[0].clientY - sy); panel.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
panel.addEventListener('touchend', function () { if (sy === null) return; panel.style.transform = ''; if (dy > 90) closeSheet(); sy = null; dy = 0; });
})();
/* ---------- schematic preview of the chosen pair ---------- */
function armSvg(code, side) {
var a = armParts(code);
var baseCol = a.base === 'clear' ? 'rgba(170,190,200,0.75)' : '#151515';
var m = side === 'L' ? 1 : -1, x0 = side === 'L' ? 34 : 166;
var tipEnd = x0 - m * 31, tipStart = x0 - m * 19;
return '<path d="M' + x0 + ' 27 L' + tipEnd + ' 19" stroke="' + baseCol + '" stroke-width="6" stroke-linecap="round"/>' +
'<path d="M' + tipStart + ' 22.2 L' + tipEnd + ' 19" stroke="' + a.acc + '" stroke-width="6.4" stroke-linecap="round"/>';
}
function drawMini() {
var it = cur(); if (!it) return;
var n = noseInfo(sel.nose).hex;
var svg = armSvg(sel.L, 'L') + armSvg(sel.R, 'R') +
'<path d="M30 24 Q100 8 170 24 L166 50 Q150 68 122 61 Q108 57 100 46 Q92 57 78 61 Q50 68 34 50 Z" fill="' + it.tint + '" fill-opacity="' + (it.group === 'mirror' ? 0.92 : 0.45) + '" stroke="rgba(40,50,45,0.55)" stroke-width="1.6"/>' +
'<path d="M44 24 Q100 13 156 24" stroke="#fff" stroke-opacity="0.65" stroke-width="2.5" fill="none" stroke-linecap="round"/>' +
'<ellipse cx="91" cy="52" rx="4.2" ry="6.4" fill="' + n + '" stroke="rgba(0,0,0,0.35)" stroke-width="0.8"/>' +
'<ellipse cx="109" cy="52" rx="4.2" ry="6.4" fill="' + n + '" stroke="rgba(0,0,0,0.35)" stroke-width="0.8"/>';
var a = $('[data-mini]'), b = $('[data-mini-big]');
if (a) a.innerHTML = svg;
if (b) b.innerHTML = svg;
}
/* ---------- quantity, add to cart, buy it now ---------- */
var qtyInput = $('[data-qty-input]');
if (addBtn) {
$$('[data-qty]').forEach(function (b) {
b.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10)); });
});
var errEl = $('[data-error]');
var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
function lines() {
var it = cur(), qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
var l = [{ id: it.id, quantity: qty, properties: { 'Nose Pad Colour': sel.nose, 'Arm Colour Left': sel.L, 'Arm Colour Right': sel.R } }];
var clipBox = $('[data-clip]');
if (clipBox && clipBox.checked && !clipBox.disabled) l.push({ id: parseInt(clipBox.value, 10), quantity: qty });
return l;
}
function addToCart(body) {
return fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
}
function fail(msg) { errEl.textContent = msg || 'Could not add to cart. Please try again.'; errEl.hidden = false; }
addBtn.addEventListener('click', function () {
var it = cur();
if (!it || !it.available || cfg.dropClosed) return;
var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
var body = { items: lines() };
if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = location.pathname; }
errEl.hidden = true; window.ATC && ATC.start(addBtn);
addToCart(body).then(function (res) {
if (!res.ok) { window.ATC && ATC.fail(addBtn); fail(res.j.description || res.j.message); return; }
if (!window.ATC) { location.href = rootUrl + 'cart'; return; }
ATC.silent(res.j);
ATC.success(addBtn, function () { setInfo(Math.round(clamp(pos))); });
}).catch(function () { window.ATC && ATC.fail(addBtn); fail(); });
});
if (buyBtn) buyBtn.addEventListener('click', function () {
var it = cur();
if (!it || !it.available || cfg.dropClosed) return;
errEl.hidden = true; buyBtn.classList.add('is-busy');
addToCart({ items: lines() }).then(function (res) {
if (!res.ok) { buyBtn.classList.remove('is-busy'); fail(res.j.description || res.j.message); return; }
location.href = rootUrl + 'checkout';
}).catch(function () { buyBtn.classList.remove('is-busy'); fail(); });
});
}
/* ---------- clock (home) ---------- */
var clock = $('[data-clock]');
if (clock) {
var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
var tick = function () { var x = new Date(), h = x.getHours() % 12 || 12; clock.textContent = p2(x.getMonth() + 1) + '/' + p2(x.getDate()) + '/' + x.getFullYear() + ' - ' + p2(h) + ':' + p2(x.getMinutes()) + ':' + p2(x.getSeconds()) + (x.getHours() >= 12 ? ' PM' : ' AM'); };
tick(); setInterval(tick, 1000);
}
/* ---------- go ---------- */
build();
var si = 0; items.forEach(function (it, i) { if (it.k === startItem.k) si = i; });
pos = target = lastTick = si;
syncSheet();
render();
live(si);
settle();
}
function boot() { document.querySelectorAll(".ssd").forEach(init); }
if (document.readyState === 'loading') document.addEventListener("DOMContentLoaded", boot); else boot();
document.addEventListener("shopify:section:load", boot);
})();
